import { createSelector } from "@reduxjs/toolkit";
import { getTodoList } from "./TodoSlice";

export const getTodoCount = createSelector(
    [getTodoList],
    (todo) => {
        if (!todo) return 0;

        const orders = todo.orders?.length;
        const bids = todo.bids?.length;
        const nudges = todo.nudges?.length;

        return orders + bids + nudges;
    }
);